import api from "@/lib/api";

// iter375 pt 1 — la connexion OAuth Zoho s'ouvre TOUJOURS dans une fenêtre dédiée « ledesk_zoho_connect » (600 × 700, centrée),
// jamais dans la fenêtre de la boîte « ledesk_zoho_mail ». Le callback prévient la fenêtre principale (postMessage) puis se ferme.
export const ZOHO_CONNECTED_EVENT = "desk:zoho-changed";

export async function openZohoConnect() {
  const { data } = await api.get("/zoho/connect");
  const w = 600, h = 700;
  const left = Math.max(0, Math.round((window.screen.width - w) / 2)), top = Math.max(0, Math.round((window.screen.height - h) / 2));
  const win = window.open(data.url, "ledesk_zoho_connect", `popup=yes,width=${w},height=${h},left=${left},top=${top}`);
  win?.focus();
  return win;
}

let _listening = false;
export function listenZohoConnected() {
  if (_listening) return;
  _listening = true;
  window.addEventListener("message", (e) => {
    if (e.origin !== window.location.origin || e.data?.type !== "desk:zoho-connected") return;
    window.dispatchEvent(new Event(ZOHO_CONNECTED_EVENT));
  });
}
